// "Sessions in dieser Woche: 1 / 3 gebucht" mit dezenter Progress-Bar.

interface WeeklyCounterProps {
  bookings: number;
  cap?: number;
}

export function WeeklyCounter({ bookings, cap = 3 }: WeeklyCounterProps) {
  const pct = Math.min(100, (bookings / cap) * 100);
  const tone =
    bookings >= cap
      ? 'border-amber-500/40 bg-amber-500/10 text-amber-300'
      : bookings === 0
        ? 'border-white/10 bg-white/[0.02] text-neutral-400'
        : 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300';
  return (
    <div className={`rounded-lg border px-3 py-2 ${tone}`}>
      <div className="flex items-center justify-between text-[11px]">
        <span className="font-medium">Sessions diese Woche</span>
        <span className="tabular">
          {bookings} / {cap}
        </span>
      </div>
      <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-white/[0.04]">
        <div
          className="h-full rounded-full bg-current transition-all"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
